// The entry host POSTs here: installed service workers route only GET, so a POST always reaches the deployed app.
export const BROWSER_ENTRY_PATH = '/continue';

// Not a QueryParamOptions member: those are carried onward by every redirect, and this one is consumed at boot.
export const BROWSER_ENTRY_TARGET_PARAM = 'to';
